// Minimal pub/sub so game logic (gameState, client, realtime) can announce
// semantic events without importing the Phaser-bound AudioManager.
const listeners = new Set();

export const audioEvents = {
  on(fn) { listeners.add(fn); return () => listeners.delete(fn); },
  emit(name, payload) {
    for (const fn of listeners) {
      try { fn(name, payload); } catch (e) { console.error('audioEvents listener error:', e); }
    }
  },
};
